export default __webpack_public_path__ + "static/media/benefit-1-cf.35c055e1.svg";